"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const HelpOutline_1 = __importDefault(require("@mui/icons-material/HelpOutline"));
const AccessTypeModal_1 = __importDefault(require("./AccessTypeModal"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const AccessTypes = ({ fullAccess, handleFullAccessChange, accountGroups }) => {
    const { classes } = useStyles();
    const [showAccessTypeModal, setShowAccessTypeModal] = (0, react_1.useState)(false);
    const handleHelpClick = () => {
        setShowAccessTypeModal(!showAccessTypeModal);
    };
    return (<>
      <div className={classes.accessDivWrapper}>
        <Typography_1.default variant="caption" sx={{ mb: 1, display: 'block' }}>
          Access Type <HelpOutline_1.default sx={{ fontSize: 16, cursor: 'pointer' }} onClick={handleHelpClick}/>
        </Typography_1.default>
        <Typography_1.default gutterBottom variant="body2">
          How would you like to share your dataset?
        </Typography_1.default>
        <div>
          <RadioGroup_1.default value={fullAccess} onChange={handleFullAccessChange}>
            <FormControlLabel_1.default value label="Grant full access to the entire dataset" control={<Radio_1.default />}/>
            <FormControlLabel_1.default value={false} disabled={accountGroups.length === 0} label="Share custom access (specific entities only)" control={<Radio_1.default />}/>
          </RadioGroup_1.default>
        </div>
      </div>
      <AccessTypeModal_1.default handleClose={handleHelpClick} open={showAccessTypeModal}/>
    </>);
};
exports.default = AccessTypes;
